import { render, staticRenderFns } from "./relevant.vue?vue&type=template&id=186e2966&"
import script from "./relevant.vue?vue&type=script&lang=js&"
export * from "./relevant.vue?vue&type=script&lang=js&"
import style0 from "./relevant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports